import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import DatePick from 'vue-date-pick'
import { VueEditor } from 'vue2-editor'

export default {
    name: 'postForm',
    data,
    methods,
    mounted,
    components: {
        DatePick,
        VueEditor
    }
}
